module.exports = __webpack_public_path__ + "img/cleaner101.355aa533.png";